import api from "../../../shared/services/api";
import { toast } from "react-toastify";

export default async function loadLeadsService(integrations) {
  try {
    const response = await api.post("/vendas/leads-estruturadas", {
      integracoes: integrations || []
    });
    return response;
  } catch (error) {
    toast.error("Erro ao carregar leads da integração");
    return null;
  }
}

